import { render, staticRenderFns } from "./RouteDashboardCard.vue?vue&type=template&id=56d4aced&scoped=true&"
import script from "./RouteDashboardCard.vue?vue&type=script&lang=js&"
export * from "./RouteDashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4aced",
  null
  
)

export default component.exports